module.exports = __webpack_public_path__ + "img/pokesmall.ef4d1468.png";